import { useEffect, useState } from 'react'
import { getMaintenanceStatus } from '@/requests/maintenance'

export const useMaintenanceStatus = (type?: string) => {
  const [isMaintenanceActive, setIsMaintenanceActive] = useState(false)

  useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const response = await getMaintenanceStatus(type)
        setIsMaintenanceActive(response.data.isMaintenanceActive)
      } catch (error) {
        // Fail safe: assume no maintenance on error
        console.error('Error checking maintenance status:', error)
        setIsMaintenanceActive(false)
      }
    }

    checkMaintenance()
  }, [type])

  return { isMaintenanceActive }
}
